<ng-container>
  <div class="container">
    <div
      class="px-4 py-2 rounded-4 community-container my-4 d-flex flex-column flex-md-row justify-content-between align-items-center gap-3"
    >
      <!-- IMAGE (will go top on mobile) -->
      <div class="order-1 order-md-2 text-center">
        <img
          src="images/suggest-idea.svg"
          alt="suggest-idea Icon"
          class="img-fluid"
          style="max-width: 200px"
        />
      </div>

      <!-- CONTENT -->
      <div class="d-flex flex-column gap-3 order-2 order-md-1">
        <div class="text-white text-lg fw-500">
          Tell us what AIKosh should build next
        </div>

        <div class="text-white text-sm">
          You use this platform to find data, train models and ship work. Where
          it slows you down is something we can fix — describe it once, and we
          will take it from there.
        </div>

        <!-- PILLS -->
        <!-- <div class="d-flex flex-wrap gap-2 text-xs">
          <div
            class="d-flex align-items-center gap-2 text-nowrap rounded-pill border px-3 py-2"
          >
            <img src="images/orange-upload1.svg" width="16" height="16" />
            <div>File Versioning & Single File Upload</div>
          </div>

          <div
            class="d-flex align-items-center gap-2 text-nowrap rounded-pill border px-3 py-2"
          >
            <img src="images/community-search.svg" width="16" height="16" />
            <div>Search in Indian languages</div>
          </div>
        </div> -->
        <button
          class="d-flex gap-1 align-items-center btn btn-primary px-3 py-2 align-self-start text-sm h-auto"
          (click)="onSuggestIdea()"
        >
          Suggest an Idea
          <img
            src="images/arrow-right-gray.svg"
            width="16"
            height="16"
            class="ms-2"
          />
        </button>
      </div>
    </div>
  </div>
</ng-container>
